/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module media-embed
 */
export { default as MediaEmbed } from './mediaembed.js';
export { default as MediaEmbedEditing } from './mediaembedediting.js';
export { default as MediaEmbedUI } from './mediaembedui.js';
export { default as AutoMediaEmbed } from './automediaembed.js';
export { default as MediaEmbedToolbar } from './mediaembedtoolbar.js';
import './augmentation.js';
